<!-- Container que decide qué versión renderizar según el flujo -->
<app-sales-review-contract-v3
  *ngIf="isFlowKrdya"
  (nextStepEvent)="onNextStep()">
</app-sales-review-contract-v3>

<app-sales-review-contract-v2
  *ngIf="!isFlowKrdya"
  (nextStepEvent)="onNextStep()">
</app-sales-review-contract-v2>
